import { gql } from '@grandvisionhq/graphql';

const shipmentMethodNotFoundFailure = gql`
  fragment ShipmentMethodNotFoundFailureFragment on UpdateCartFailure {
    ... on ShipmentMethodNotFoundFailure {
      cartId
      message
      code
      reason
    }
  }
`;
const shipmentMethodDoesNotMatchCartFailure = gql`
  fragment ShipmentMethodDoesNotMatchCartFailureFragment on UpdateCartFailure {
    ... on ShippingMethodDoesNotMatchCartFailure {
      cartId
      message
      code
      reason
    }
  }
`;
const unknownUpdateCartFailure = gql`
  fragment UnknownUpdateCartFailureFragment on UpdateCartFailure {
    ... on UnknownUpdateCartFailure {
      cartId
      message
      code
      reason
    }
  }
`;

export { shipmentMethodDoesNotMatchCartFailure, shipmentMethodNotFoundFailure, unknownUpdateCartFailure };
//# sourceMappingURL=cart-mutation-failures.js.map
